import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import Paper from '@material-ui/core/Paper';

import OrdersTableHead from './OrdersTableHead';

const styles = theme => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    margin: '-20px -20px 0 -20px',
    padding: '20px 20px 0 20px',
  },
  ordersTableHeadContainer: {
    [theme.breakpoints.down('sm')]: {
      overflowX: 'hidden',
    },
  },
  paper: {
    width: '100%',
    overflow: 'hidden',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    [theme.breakpoints.down('sm')]: {
      width: 1100,
    },
  },
  table: {
    minWidth: 1100,
    tableLayout: 'fixed',
  },
  typography: {
    paddingLeft: 10,
    paddingBottom: 8,
  },
  iconFilter: {
    width: 16,
    height: 16,
  },
});

const OrdersTableNoBody = ({
  items,
  variant,
  sort,
  sortBy,
  onSortingChange,
  loading,
  count,
  className,
  ordersTableHeadContainerRef,
  classes,
}) => (
  <div className={classNames(classes.root, className)}>
    {items.length > 0 &&
      <Typography className={classes.typography}>
        Orders ({count})
      </Typography>
    }
    <div
      ref={ordersTableHeadContainerRef}
     className={classes.ordersTableHeadContainer}
    >
    <Paper
      className={classes.paper}    
    >
      {items.length > 0 &&
        <Fragment>
          <Table className={classes.table}>
            <OrdersTableHead
              variant={variant}
              sort={sort}
              sortBy={sortBy}
              onSortingChange={onSortingChange}
              loading={loading}
            />
          </Table>
        </Fragment>
      }
    </Paper>
    </div>
  </div>
);

OrdersTableNoBody.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  variant: PropTypes.oneOf([
    'workflow',
    'combined',
    'connected',
  ]).isRequired,
  sort: PropTypes.oneOf(['asc', 'desc']),
  sortBy: PropTypes.string,
  onSortingChange: PropTypes.func,
  loading: PropTypes.number,
  count: PropTypes.number,
  className: PropTypes.string,
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

OrdersTableNoBody.defaultProps = {
  sort: null,
  sortBy: null,
  onSortingChange: null,
  loading: 0,
  count: 0,
  className: '',
};

export default withStyles(styles)(OrdersTableNoBody);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableNoBody.js